module.exports = __webpack_public_path__ + "img/mfa-bg.5ad0b91e.png";